import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import CampaignPreview from './CampaignPreview'

const Campaigns = ({
  collection,
  items,
  type,
  events,
}) => {
  return (
    <div className="camps">
      {
        collection.slice(0, items).map((props, i) => {
          const preview = events.find(item => item.id == props.eventId).preview;
          return (
            <Link className="camp__link" to={`/campaign/${props.id}`} key={i}>
              <CampaignPreview {...props} preview={preview}/>
            </Link>)
        })  
      }
    </div>
  )
}

function mapStateToProps(state, props) {
  return { events: state.events }
}

export default connect(mapStateToProps)(Campaigns)


// WEBPACK FOOTER //
// ./src/components/Campaigns.js